import { render, staticRenderFns } from "./alarm_record.vue?vue&type=template&id=a3e80424&scoped=true"
import script from "./alarm_record.vue?vue&type=script&lang=js"
export * from "./alarm_record.vue?vue&type=script&lang=js"
import style0 from "./alarm_record.vue?vue&type=style&index=0&id=a3e80424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e80424",
  null
  
)

export default component.exports